import { Table } from '@winnin/winnin_ui.components.table'

import type { TOwnedTopicsTableViewProps } from './owned-topics-table.types'

import './owned-topics-table.styles.scss'

export const OwnedTopicsTableView = ({ headers, tableData }: TOwnedTopicsTableViewProps) => {
  return <Table headers={headers} data={tableData} />
}
